import React, {Fragment, useEffect, useState} from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import {Box, Grid} from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Card from '../../components/Card/Card.jsx';
import CardBody from '../../components/Card/CardBody.jsx';
import CardHeader from '../../components/Card/CardHeader';
import Button from '../../components/CustomButtons/Button.jsx';
import {API, Storage} from 'aws-amplify';
import {Typography} from '@material-ui/core';
import {Form, Input, Select} from 'antd';
import {useForm} from 'antd/es/form/Form';
import {SaveOutlined} from '@ant-design/icons';

const styles = {
  figure: {
    padding: '5px',
    border: '1px solid #ccc'
  },
  attachmentThumb: {
    width: '100%',
    cursor: 'pointer',
    border: '1px solid #ccc',
    padding: '5px'
  },
  boxPadding: {
    paddingLeft: '10px',
    paddingTop: '10px'
  }
};

const ClientDocumentsEdit = ({classes, clientDocumentData, clientDocumentId}) => {
  const [documentForm] = useForm();
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientsList, setClientsList] = useState([]);
  const [documentCategories, setDocumentCategories] = useState([]);
  const [clientsListLoading, setClientsListLoading] = useState(false);
  const [documentDownloadUrl, setDocumentDownloadUrl] = useState(null);
const [has_fww_portal_bucket, setHas_fww_portal_bucket] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const sanitizeKey = key => {
    if (!key || typeof key !== 'string') return key;
    return key.replace(/^public\//, '');
  };

const checkForbidden = async key => {
    if (!key || typeof key !== 'string' || !key.trim()) return false;
    try {
      await Storage.get(sanitizeKey(key));
      return false;
    } catch (e) {
      return true;
    }
  };

  const AttachmentPreview = ({item, clientDocumentId}) => {
    const [url, setUrl] = useState(null);
    const [forbidden, setForbidden] = useState(false);

    useEffect(() => {
      checkForbidden(item).then(isForbidden => {
        setForbidden(isForbidden);
        if (!isForbidden) {
          Storage.get(sanitizeKey(item), {expires: 3600}).then(setUrl);
        }
      });
    }, [item]);

    if (!forbidden && !url)
      return (
        <div style={{height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Loading...</div>
      );

    if (forbidden) {
      const portalUrl = `https://admin.fwwportal.com/en/dashboard/back-office/documents/client/details/${clientDocumentId}`;
      return (
        <a href={portalUrl} target="_blank" rel="noopener noreferrer">
          View in Portal
        </a>
      );
    }

    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {item.split('/').pop()}
      </a>
    );
  };

  const fetchClients = () => {
    setClientsListLoading(true);
    API.post('commons', '/fetch', {
      body: {
        context: 'clientDocumentsCategories',
        fields: ['*']
      }
    }).then(res => {
      console.log(res);
      setDocumentCategories(res);
    });
    API.get('clients', '/get-list-not-deleted', {})
      .then(response => {
        setClientsList(response);
      })
      .catch(error => {
        console.log(error);
        setClientsList([]);
      })
      .finally(() => {
        setClientsListLoading(false);
      });
  };

  const handleSave = values => {
    setLoading(true);
    API.put('client-documents', `/id/${clientDocumentId}`, {body: values})
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
        API.put('client-documents', `/id/${clientDocumentId}`, {body: values})
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            console.log(error);
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {
    if (clientDocumentData) {
      setHas_fww_portal_bucket(clientDocumentData.has_fww_portal_bucket || false);

      const files = clientDocumentData.file_refs || clientDocumentData.attachments || [];
      setAttachments(files);

      // Access validation is now handled per attachment in AttachmentPreview
      documentForm.setFieldsValue({clientId: clientDocumentData.clientId});
      documentForm.setFieldsValue({description: clientDocumentData.description});
      documentForm.setFieldsValue({categoryID: clientDocumentData.categoryID});
      if (files.length > 0) {
        setTimeout(() => setEditMode(true), 3000);
      }
    }
  }, [clientDocumentData]);

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <Card>
            <CardHeader color='rose' icon>
              <div className={classes.flexEnd}>
                <h4 className={classes.cardIconTitle}>{editMode ? 'Edit Record: ' : 'View Record: '}</h4>
                <>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editMode}
                        onChange={() => setEditMode(prevState => !prevState)}
                        value='edit_mode'
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label={editMode ? 'Edit Mode' : 'Read Only'}
                  />
                </>
              </div>
            </CardHeader>
            <CardBody>
              <Form form={documentForm} layout={'vertical'} onFinish={handleSave} disabled={!editMode}>
                <Form.Item name='clientId' label={'Client'} rules={[{required: true, message: 'Field is required'}]}>
                  <Select
                    disabled={true}
                    showSearch={true}
                    options={clientsList.map(i => ({
                      ...i,
                      label: [i.first_name, i.last_name].join(' '),
                      value: i.id
                    }))}
                  ></Select>
                </Form.Item>
                <Form.Item
                  name='categoryID'
                  label={'Category'}
                  rules={[{required: true, message: 'Field is required'}]}
                >
                  <Select
                    showSearch={true}
                    options={documentCategories.map(i => ({
                      ...i,
                      label: i.categoryName,
                      value: i.id
                    }))}
                  ></Select>
                </Form.Item>
                <Form.Item name='description' label={'Description'}>
                  <Input.TextArea />
                </Form.Item>
                <Form.Item>
                  <Button type={'primary'} htmlType={'submit'} icon={<SaveOutlined />}>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Box boxShadow={2} className={styles.boxPadding}>
            {attachments && has_fww_portal_bucket === false ? (
              attachments.length > 0 ? (
                <ul style={{paddingLeft: 16}}>
                  {attachments.map((item, index) => (
                    <li key={index}>
                      <AttachmentPreview item={item} clientDocumentId={clientDocumentId} />
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography variant='body2'>No attachments found.</Typography>
              )
            ) : (
              <div style={{textAlign: 'center', padding: '20px'}}>
                <Typography variant='h6' gutterBottom>
                  Access Denied
                </Typography>
                <Typography variant='body1' gutterBottom>
                  This document is not accessible from here. Please view it in the FWW Portal.
                </Typography>
                <Button
                  color='info'
                  variant='contained'
                  onClick={() => {
                    const url = `https://admin.fwwportal.com/en/dashboard/back-office/documents/client/details/${clientDocumentId}`;
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                >
                  View in Portal
                </Button>
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ClientDocumentsEdit;
